import { gql, useMutation } from '@apollo/client'
import { useToast } from 'components/Dashboard/Toast'
import { Modal2 } from 'components/Modal'
import SubmitButton from 'components/SubmitButton'
import TextInput from 'components/TextInput'
import { Form, Formik } from 'formik'
import { ChangeKitStatusMutation, ChangeKitStatusMutationVariables } from './__generated__/ChangeKitStatusMutation'

export const changeKitStatusMutation = gql`
  mutation ChangeKitStatusMutation($input: ChangeKitStatusInput!) {
    changeKitStatus(input: $input) {
      success
      message
      kit {
        id
        status
      }
    }
  }
`

interface DeactivateKitModalProps {
  kitId: string
  onRequestClose: () => void
}

const DeactivateKitModal = ({ kitId, onRequestClose }: DeactivateKitModalProps) => {
  const [changeKitStatus] = useMutation<ChangeKitStatusMutation, ChangeKitStatusMutationVariables>(
    changeKitStatusMutation
  )

  const { addToast } = useToast()

  return (
    <Modal2 isOpen onRequestClose={onRequestClose} header="Deactivate Kit">
      <Formik
        initialValues={{ zdRef: '', reason: '' }}
        onSubmit={async (values, { setStatus }) => {
          try {
            const resp = await changeKitStatus({
              variables: {
                input: {
                  kitId,
                  status: 'INACTIVE',
                  context: 'Deactivate Kit Modal',
                  reason: values.reason,
                  zdRef: values.zdRef,
                },
              },
            })

            if (!resp.data.changeKitStatus.success) {
              throw new Error(resp.data.changeKitStatus.message || 'Something went wrong')
            }

            onRequestClose()
            addToast({
              messageType: 'success',
              title: 'Deactivated',
              content: <>Kit deactivated</>,
              timeout: 5000,
            })
          } catch (err) {
            setStatus({ error: err.message })
          }
        }}
      >
        {({ isSubmitting, status }) => (
          <Form>
            <TextInput name="reason" label="Reason for reactivating kit" />
            <TextInput name="zdRef" label="Zendesk ticket no (if applicable)" />

            <div className="buttons is-right mt-5">
              <SubmitButton className="is-primary" submitting={isSubmitting} disabled={isSubmitting}>
                Deactivate Kit
              </SubmitButton>
            </div>
            {status?.error && (
              <article className="message is-danger">
                <div className="message-body">Failed: {status.error}</div>
              </article>
            )}
          </Form>
        )}
      </Formik>
    </Modal2>
  )
}

export default DeactivateKitModal
